import { Injectable } from '@angular/core';

import { Subscription } from 'rxjs';

import { AbstractHypeService } from '../../../Common/Layout/services/abstract-hype.service';
import { CoreDialogService } from '../../../Core/Dialogs/services/dialog.service';
import { AmplifyRouteModel } from '../../AmplifyRouter/models/amplify-route.model';
import { AmplifyRoutingService } from '../../Core/services/amplify-routing.service';
import { WireCreateDialogComponent } from '../components/WireCreateDialog/wire-create-dialog.component';
import { AmplifyRouteTypeEnum } from '../../AmplifyRouter/enums/amplify-route-type.enum';
import { ConfigService } from '../../../Core/Config/services/config.service';
import { PACreateDialogComponent } from '../components/WireCreateDialog/PACreateDialog/pa-create-dialog.component';

enum HypeType {
    wire
}

@Injectable()
export class WireHypeService extends AbstractHypeService {
    public currentRoute: AmplifyRouteModel;

    private hypeType: HypeType;
    private subscriptions: Subscription[] = [];

    constructor(
        private coreDialogService: CoreDialogService,
        private amplifyRoutingService: AmplifyRoutingService,
        private configService: ConfigService
    ) {
        super();
        this.subscriptions.push(
            this.amplifyRoutingService.getCurrentRoute().subscribe(
                route => {
                    this.currentRoute = route;
                    this.initializeHype();
                }
            )
        );
    }

    private initializeHype(): void {
        switch (this.currentRoute.type) {
            case AmplifyRouteTypeEnum.wireHype:
            case AmplifyRouteTypeEnum.editorialHype:
                this.hypeConfig = {
                    icon: 'fa-kit-duotone fa-agpr-hype-newswire',
                    headingText: 'Amplify.hype.wire.headline',
                    line1Text: 'Amplify.hype.wire.line1',
                    line2Text: 'Amplify.hype.wire.line2',
                    linkText: 'Amplify.hype.wire.link',
                    hideButtonIcon: true
                };
                break;
            default:
                break;
        }
        this.hypeConfigProvider.next(this.hypeConfig);
    }


    buttonClicked(): void {
        if (this.configService.brandGUIDIsPaMedia()) {
            this.coreDialogService.open(PACreateDialogComponent);
        } else {
            window.open('https://www.agilitypr.com/newswire-provisioning-form/', '_blank');
        }
    }

    secondaryButtonClicked(): void {}
}
